import { BaseIcon, BaseIconProps } from './BaseIcon';

export const MessageSquareGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="messageSquareGrad" {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="url(#messageSquareGrad)" />
  </BaseIcon>
);
